module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ch5",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Title-ct",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "39",
      "id": "pg_39",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cn"
  }, [_vm._v("5.")]), _vm._v(" BATTLING THE FAKIRS, SWINDLERS, AND MANUFACTURERS OF BAD WHISKEYS")])])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_c('i', [_vm._v("The truth gets buried under an avalanche of money and advertising.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-Source-ceps"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—BARACK OBAMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("T")]), _vm._v("hose early years of Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s initiation into publishing were awash with charlatans, mountebanks, and scandalmongers who held the truth in disdain"), _c('span', {
    staticClass: "small"
  }, [_vm._v(".")]), _vm._v(" In the world of popular news no one was more powerful or had more contempt for the facts than the newspaper magnate William Randolph Hearst. No one could touch Hearst’s ability to create the sensational from the ordinary in an ocean of publicity, not even his idol, the great Joseph Pulitzer. Having inherited enormous wealth from his father’s silver mines and other investments, Hearst used his money to build a newspaper empire to rival Pulitzer’s own.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When Hearst’s "), _c('i', [_vm._v("New York Journal")]), _vm._v(" began to threaten Pulitzer’s circulation at "), _c('i', [_vm._v("The New York World")]), _vm._v(" in 1895, the aging publisher finally took note of the new boy. But it was too late. Many of Pulitzer’s editors, writers, and illustrators had already been poached by the “Hearst Summons.” By 1897 it had become an institution in American journalism, where the “summoned”—like the "), _c('i', [_vm._v("World’s")]), _vm._v(" Arthur Brisbane—knew they would be unable to resist the temptations that “the Chief” Hearst offered, both financially and in terms of power."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-1",
      "id": "notes-ch5_1",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Brisbane became Hearst’s friend and the backbone of his journalism empire. Not bad for a “one-time socialist who had drifted pleasantly into the profit system … in some respects a vest-pocket Hearst—a personal enigma, a workhorse, a "), _c('span', {
    attrs: {
      "aria-label": "40",
      "id": "pg_40",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("madman for circulation, a liberal who had grown conservative, an investor.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-2",
      "id": "notes-ch5_2",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" Lesser men—and women—came under Hearst’s seemingly magnetic influence and hadn’t the willpower to escape. Once Hearst had begun his lifetime practice of poaching his competitors’ ablest staff, there was no stopping his attempts to crush his opposition. So when it came to telling the truth, Hearst became one of Robert Collier’s greatest adversaries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In looking back over his career, and his association with James H. Hare, one of the great early news photographers, Robert Collier explained that when “Jimmy Hare blew in,” his life changed course abruptly. Hearst was brewing the biggest fake news story yet of his career: inventing the beginning of the Spanish-American War. Understandably Collier dispatched Jimmy Hare to Cuba to see what was really happening. “Sending Hare to Havana that morning involved me in more troubles and wars and libel suits than any one act in my life,” he lamented. “It turned me from the quiet paths of a literary career into [an] association with war correspondents, politicians, muckrakers, and advertising men.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-3",
      "id": "notes-ch5_3",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Hearst was undeniably behind many of the libel suits and troubles. When stripped of his press credentials, Hearst seemed shy, modest, indecisive, and a courteous gentle giant of a man (he was nearly six feet three)"), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-107",
      "id": "footnote-107-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" with a timid disposition. With his press hat on, he was a brazen “Caesar, Charlemagne, and Napoleon.” Unlike Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(", Hearst’s shyness and persona were a sham, save for his high-pitched girly voice. His father once said, “There’s only one thing that’s sure about my boy Bill. I’ve been watching him and notice that when he wants cake, he wants cake, and he wants it now.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-4",
      "id": "notes-ch5_4",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" Hearst was nothing short of a megalomaniac who delighted in catching people out, playing practical jokes on unsuspecting employees, inventing news, and admiring his own “greatness.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-5",
      "id": "notes-ch5_5",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" He had whipped up an orgy of articles condemning the Spanish occupation of Cuba, and applauded the island’s rebels. The Pulitzer "), _c('i', [_vm._v("World")]), _vm._v(" correspondent, Sylvester Scovel, had been jailed by the Spaniards, and Pulitzer was mounting a campaign to free him. En"), _c('span', {
    attrs: {
      "aria-label": "41",
      "id": "pg_41",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("vious of their free publicity, Hearst sent Frederic Remington as his war correspondent/illustrator to beef up the story.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But once in Havana, Remington cabled that he was bored: “Everything is quiet. There is no trouble here. There will be no war. I wish to return.—Remington.” Like a Napoleon, Hearst responded: “Please remain. You furnish the pictures and I’ll furnish the war.—W. R. Hearst.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-6",
      "id": "notes-ch5_6",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" And so he did. When the American battle cruiser "), _c('i', [_vm._v("Maine")]), _vm._v(" blew up in Havana Harbor,"), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-106",
      "id": "footnote-106-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Hearst engaged in the most ruthless, truthless campaign in news history, claiming that the Spaniards had blown up the American ship. He financed “fact-finding” missions to Havana attended by a carefully selected group of congressmen and senators happy to have an all-expenses-paid holiday. He put words into Vice President Theodore Roosevelt’s mouth, “cheering” his newspapers of “great influence and circulation” and ignoring “suggestions of various kinds that … cannot be described as patriotic or loyal to the flag of this country.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-7",
      "id": "notes-ch5_7",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" Even Roosevelt’s denial in the "), _c('i', [_vm._v("New York Post")]), _vm._v(" that any such statement had been made to Hearst’s "), _c('i', [_vm._v("Journal")]), _vm._v(" was ignored. The enraged vice president said: “The alleged interview with me … is an invention from beginning to end. It is difficult to understand the kind of infamy that resorts to such methods.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-8",
      "id": "notes-ch5_8",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In contrast to Hearst’s “yellow journalism,” "), _c('i', [_vm._v("Collier’s")]), _vm._v(" was widely admired for its news reporting, “as The National Weekly by the thorough way in which it covered our war with Spain.” The chief "), _c('i', [_vm._v("Collier’s")]), _vm._v(" correspondent, twenty-five-year-old Frederick Palmer, was experienced, writing about his second war. Jimmy Hare’s photographs told the story clearly in pictures.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("To Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s and Robert Collier’s consternation, the truth seemed to be a commodity in diminishing supply in newsprint. Hearst and others who bent it to their will, meanwhile, grew in popularity. That said, there were other publishers, too, who worried about their reputations, like Cyrus Curtis, owner of the "), _c('i', [_vm._v("Ladies’ Home")]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "42",
      "id": "pg_42",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("Journal")]), _vm._v(", and Arthur B. Turnure, owner of "), _c('i', [_vm._v("Vogue")]), _vm._v(", which first appeared in December 1892. Of the two, Turnure had the most to lose by any association with the Hearst news and magazine empire, since his 250 stockholders were members of the "), _c('i', [_vm._v("Social Register")]), _vm._v(", and included the wives of Stuyvesant Fish, Cornelius Vanderbilt, and D. Percy Morgan. Turnure himself was from a wealthy family, as was his art director at "), _c('i', [_vm._v("Vogue")]), _vm._v(", Harry McVickar, whose great-grandfather was the wealthy merchant and prominent New Yorker Stephen Whitney. McVickar was also a member of the Four Hundred."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-9",
      "id": "notes-ch5_9",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The "), _c('i', [_vm._v("Ladies’ Home Journal")]), _vm._v(" began life as the “Woman and the Home” section of Curtis’s magazine, "), _c('i', [_vm._v("Tribune and the Farmer")]), _vm._v(". Initially edited by Mrs. Curtis, who had no such grand connections, the magazine grew to more than four hundred thousand subscribers by the autumn of 1887, selling advertising space at the rate of two dollars an agate line."), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-105",
      "id": "footnote-105-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" By 1893 subscriptions had increased to seven hundred thousand. Its back-page advertisement sold for four thousand dollars."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-10",
      "id": "notes-ch5_10",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" Four years earlier Curtis believed he had assured his magazine’s future by hiring Edward William Bok.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Bok, who was seven years old when his parents immigrated to the United States from the Netherlands, was known to have a streak of reforming, idealistic zeal. While he had done a great deal to improve the "), _c('i', [_vm._v("Ladies’ Home Journal")]), _vm._v(", he was not above making a gaffe or two—like commissioning Kipling’s poem “The Female of the Species,” containing the line “The female of the species is more deadly than the male.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-11",
      "id": "notes-ch5_11",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("One of Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s greatest character traits was that he did not suffer from the “not-invented-here-syndrome.” He learned from all his subordinates and competitors—both good and bad—and devised over time an ethos that served him well throughout his career. "), _c('span', {
    attrs: {
      "aria-label": "43",
      "id": "pg_43",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Probably no one incident demonstrates this better than the "), _c('i', [_vm._v("Ladies’ Home Journal")]), _vm._v("’s battle against “the Nostrum of Evil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('i', [_vm._v("Collier’s")]), _vm._v(" had earned its distinctive reputation with its reporting on the Spanish-American War and its series on immigrant labor problems in 1903, when articles attacking noxious medicines first appeared in "), _c('i', [_vm._v("Ladies’ Home Journal.")]), _vm._v(" Later that same year "), _c('i', [_vm._v("Collier’s")]), _vm._v(" editor Hapgood wrote a humorous editorial poking fun at William Jennings Bryan’s magazine, "), _c('i', [_vm._v("The Commoner")]), _vm._v(", which had been “hammering monopolies” and giving large advertising space to a product called “Liquozone”—a remedy claiming to cure more than “forty diseases from cancer to dandruff.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-12",
      "id": "notes-ch5_12",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" At Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s urging, Hapgood barged into the hottest crusade in the world of advertising. Patent medicines that made false claims were dangerous, perhaps deadly, and if the magazines continued to accept their advertising, in Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s opinion, they were guilty by association.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Even the highest-grade magazines were filled with the most unreliable patent-medicine advertising,” Edward Bok wrote. “The business pages fairly reeked with them. It was the acceptable business in the offices of all magazines, high and low.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-13",
      "id": "notes-ch5_13",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" That is, until Cyrus Curtis decided that the pages of his magazine should be free of them, issuing a direct order to the advertising department that “no advertisements of proprietary medicines of any kind would be accepted for publication.” The finance director bewailed the decision and tried to get Bok to prevail on Curtis to change his mind. When Bok approached Curtis, the latter just looked back at him blankly. Despite putting his publication in serious financial difficulty for the next several months, Curtis stuck to his guns.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(", on behalf of Robert Collier, took up the cudgels next. So began the series of articles by Samuel Hopkins Adams, who had previously been connected with "), _c('i', [_vm._v("McClure’s Magazine")]), _vm._v(". They ran in "), _c('i', [_vm._v("Collier’s")]), _vm._v(" from 1904, titled “Fraud—Articles on the Nostrum of Evil and Quacks.” The first series concentrated on specific remedy types and their dangers: “Peruna and Bracers,” “Liquozone,” “The Subtle Poisons,” “Preying on the Incurables,” "), _c('span', {
    attrs: {
      "aria-label": "44",
      "id": "pg_44",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and “The Fundamental Fakes.” In its introduction "), _c('i', [_vm._v("Collier’s")]), _vm._v(" asserted its exposure of:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "Extract-No-Indent-ext1"
  }, [_c('i', [_vm._v("patent-medicine methods, and the harm done to the public by this industry, founded mainly on fraud and poison. Results of the publicity given to these methods can already be seen in the steps recently taken by the National Government, some State Governments and of a few of the more reputable newspapers. The object of the series is to make the situation so familiar and thoroughly understood that there will be a speedy end to the worst aspects of the evil.")]), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-14",
      "id": "notes-ch5_14",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-Before--tx"
  }, [_vm._v("First among the offenders was Pond’s Extract, with its claims to cure meningitis. Peruna exploited fears over the outbreak of yellow fever in New Orleans, and “acetanilid will undoubtedly relieve headaches of certain kinds; but acetanilid, as the basis for headache powders, is prone to remove the cause of symptoms permanently by putting a complete stop to heart action.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-15",
      "id": "notes-ch5_15",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" The article then attacked the so-called testimonials given by satisfied patients: “The man who dies in spite of the patent-medicine—or perhaps because of it—doesn’t bear witness for what it did to him.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-16",
      "id": "notes-ch5_16",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" Bona fide testimonials from purchasers of the various medicines ran frequently in the form of advertising, but no one knew if the writer was already dead of his or her uncured illness.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The second series in "), _c('i', [_vm._v("Collier’s")]), _vm._v(" concentrated on all the quack practitioners: “For every ill there is a ‘sure-cure,’” "), _c('i', [_vm._v("Collier’s")]), _vm._v(" reminded its readers. “The more deadly the disease the more blatantly certain is the quack that he alone can save you, and in extreme cases, where he has failed to get there earlier, he may even raise you from your coffin and restore you to your astonished and admiring friends. Such things have happened—in the advertising columns of newspapers.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-17",
      "id": "notes-ch5_17",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Next "), _c('i', [_vm._v("Collier’s")]), _vm._v(" lashed out at newspapers that were so kind, considerate, and careful of their advertisers as to publish the “homicides” that would be injurious to the advertiser’s own health. A Chicago newspaper was accused of “compelling its political editor "), _c('span', {
    attrs: {
      "aria-label": "45",
      "id": "pg_45",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to tout for fake [e]ndorsements of a nostrum.” How did "), _c('i', [_vm._v("Collier’s")]), _vm._v(" know? An insider told the weekly that only two Chicago papers were free from the practice."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-18",
      "id": "notes-ch5_18",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Robert Collier was thrilled with the results. In 1905 Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was promoted to business manager at "), _c('i', [_vm._v("Collier’s")]), _vm._v(", earning not far from a mammoth forty thousand dollars a year."), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-104",
      "id": "footnote-104-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" By October 1906, "), _c('i', [_vm._v("Collier’s")]), _vm._v(" “The Great American Fraud” unmasked most advertising scams related to patent medicines and forced Congress into passing a reform that evolved into the Food and Drug Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That same month "), _c('i', [_vm._v("Collier’s")]), _vm._v(" lost the advertising of the Postum Cereal Company, of Grape-Nuts fame. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had approved the campaign in the magazine protesting against the untruthful allegations that the cereal could prevent appendicitis, and a good deal more besides. Charles W. Post rebutted the claim by asserting in national newspapers—some of which were certainly owned by William Randolph Hearst—that it was merely “sour grapes” that made "), _c('i', [_vm._v("Collier’s")]), _vm._v(" attack the company’s products. Sour grapes? Why yes, old CW replied, for Post refused to advertise in their weekly magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What CW hadn’t counted on was that Robert Collier would sue Postum Cereal Company for its clear allegations of blackmail against "), _c('i', [_vm._v("Collier’s")]), _vm._v(". Five years later, in January 1911, long after Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had moved on to new pastures, "), _c('i', [_vm._v("Collier’s")]), _vm._v(" was awarded fifty thousand dollars in damages. Though the verdict was set aside on appeal due to a legal technicality, Robert Collier was happy, nonetheless. The original verdict was vindication enough."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-19",
      "id": "notes-ch5_19",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("The campaign to promote the nation’s welfare was also waged against the likes of the sleazy society magazine "), _c('i', [_vm._v("Town Topics")]), _vm._v(", and Hearst’s newspapers. "), _c('i', [_vm._v("Town Topics")]), _vm._v(", a voyeuristic tabloid that often viciously bit the high-society hands that fed its columns, was the "), _c('span', {
    attrs: {
      "aria-label": "46",
      "id": "pg_46",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("first to be tackled. On October 20, 1904, it published a rather scandalous paragraph about Alice, the eldest child of Theodore Roosevelt, accusing her of “wearing costly lingerie [and] indulging in fancy dances” and “indulging freely in stimulants.… Flying all around Newport without a chaperone was another thing … but if the young woman knew some of the tales that are told at the clubs in Newport she would be more careful in the future about what she does and how she does it.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-20",
      "id": "notes-ch5_20",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In reply "), _c('i', [_vm._v("Collier’s")]), _vm._v(" editor Hapgood wrote an editorial calling "), _c('i', [_vm._v("Town Topics")]), _vm._v(" “the most degraded paper of any prominence in the United States” and a “sewer sheet.” Before it went into print, Robert Collier personally added a last paragraph. He asserted that the editor of "), _c('i', [_vm._v("Town Topics")]), _vm._v(" had a social standing “somewhat worse than that of an ordinary forger, horse-thief, or second-story man.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("But was it libelous, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" asked? Col. William d’Alton Mann, "), _c('i', [_vm._v("Town Topics")]), _vm._v("’ editor, had already garnered a reputation for extorting “loans” or “cash payments”—euphemisms for blackmail—for "), _c('i', [_vm._v("not")]), _vm._v(" printing some of the more colorful profiles in his social column. Robert Collier, as a gallant young society man, was well aware of the practice, and sought to bring it out into the open."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-21",
      "id": "notes-ch5_21",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" Colonel Mann somehow persuaded the Manhattan District Attorney’s Office to place the matter before a grand jury for adjudication, and Hapgood was indicted on charges of criminal libel. "), _c('i', [_vm._v("Collier’s")]), _vm._v(" lawyers dug up enough on Colonel Mann’s dubious practices to cause the jury to sympathize with the written statement, and Hapgood was acquitted. The crusading reporter Mark Sullivan wrote later that:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "Extract-No-Indent-ext1"
  }, [_c('i', [_vm._v("The")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("Town Topics")]), _vm._v(" "), _c('i', [_vm._v("suit did for")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("Collier’s")]), _vm._v(" "), _c('i', [_vm._v("what Collier most desired and needed. The first-page stories and heavy headlines with which the daily papers reported the trial, the parade of names of the best-known figures in New York yielding to intimidation or occasionally resisting it, as the")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("New York Sun")]), _vm._v(" "), _c('i', [_vm._v("said, “with courage, celerity, and artistic thoroughness”—all combined to give")]), _vm._v(" "), _c('i', {
    staticClass: "extract-no-indent-ext1-_span-italic-characters-ital"
  }, [_vm._v("Collier’s")]), _vm._v(" "), _c('i', [_vm._v("esteem, éclat, kudos. It became, and for years re")]), _c('span', {
    attrs: {
      "aria-label": "47",
      "id": "pg_47",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("mained, the most influential periodical in the country, in many respects the most distinguished America has ever had.")]), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-22",
      "id": "notes-ch5_22",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-Before--tx"
  }, [_vm._v("While Sullivan’s praise exaggerates "), _c('i', [_vm._v("Collier’s")]), _vm._v(" significance a hundred years on, there is no doubt that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" learned scores of valuable lessons about running a national publication while at "), _c('i', [_vm._v("Collier’s")]), _vm._v(". By 1907 Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was the United States’ highest-paid executive, but he’d decided that it was time for him to put his own ideas to the test. Rob Collier couldn’t believe his ears when Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" told him. “You know perfectly well, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(",” he said, “no one else is going to pay you that much money. You’re not worth it.” Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" amiably agreed. He wasn’t going to go out and get another job. “I’m going out to see if I can’t make more than that,” he replied."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch5#notes-ch5-23",
      "id": "notes-ch5_23",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba1d400c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 93
// module chunks = 0